export const clrLive = '#f75d6e';
export const clrPredicted = '#3e88f3';
export const clrHistoric = '#a6b3b8';
export const clrBenchmark = '#f2a068';

export const chartRed = '#da532c';
export const chartYellow = '#FFFF00';
export const chartBlue = '#2d89ef';

export const clrUrgency1 = '#f7e96f';
export const clrUrgency2 = '#edb46a';
export const clrUrgency3 = '#ef5b47';
export const GMapURL = `https://maps.google.com/maps/api/js?key=`;
